/**
 * @flow
 * @relayHash a155d7eae5f2b8e526feb05f80d0511f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DestinationClassificationType = "COMMERCIAL" | "HOUSE" | "RESIDENTIAL_BUILDING" | "UNDEFINED" | "%future added value";
export type ReceiverPermissions = "CAN_CLASSIFY_DESTINATION" | "CAN_EDIT_FULL_ADDRESS" | "UNDEFINED" | "%future added value";
export type successQueryVariables = {|
  packageId: number
|};
export type successQueryResponse = {|
  +privatePackageTracker: ?{|
    +destinationInfo: ?{|
      +firstLine: ?string,
      +secondLine: ?string,
      +complement: ?string,
      +coordinates: ?{|
        +lat: number,
        +lng: number,
      |},
      +classificationType: ?DestinationClassificationType,
      +instructions: ?string,
      +additionalReceivers: ?string,
    |},
    +permissions: ?$ReadOnlyArray<ReceiverPermissions>,
  |}
|};
export type successQuery = {|
  variables: successQueryVariables,
  response: successQueryResponse,
|};
*/

/*
query successQuery(
  $packageId: Int!
) {
  privatePackageTracker(packageId: $packageId) {
    destinationInfo {
      firstLine
      secondLine
      complement
      coordinates {
        lat
        lng
      }
      classificationType
      instructions
      additionalReceivers
    }
    permissions
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'packageId',
        type: 'Int!',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'privatePackageTracker',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'packageId',
            variableName: 'packageId'
          }
        ],
        concreteType: 'PrivateTrackerResultNode',
        plural: false,
        selections: [
          {
            kind: 'LinkedField',
            alias: null,
            name: 'destinationInfo',
            storageKey: null,
            args: null,
            concreteType: 'PrivateTrackerDestinationInfoNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'firstLine',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'secondLine',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'complement',
                args: null,
                storageKey: null
              },
              {
                kind: 'LinkedField',
                alias: null,
                name: 'coordinates',
                storageKey: null,
                args: null,
                concreteType: 'PointNode',
                plural: false,
                selections: [
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'lat',
                    args: null,
                    storageKey: null
                  },
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'lng',
                    args: null,
                    storageKey: null
                  }
                ]
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'classificationType',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'instructions',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'additionalReceivers',
                args: null,
                storageKey: null
              }
            ]
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'permissions',
            args: null,
            storageKey: null
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'successQuery',
      type: 'Query',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'successQuery',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    params: {
      operationKind: 'query',
      name: 'successQuery',
      id: null,
      text:
        'query successQuery(\n  $packageId: Int!\n) {\n  privatePackageTracker(packageId: $packageId) {\n    destinationInfo {\n      firstLine\n      secondLine\n      complement\n      coordinates {\n        lat\n        lng\n      }\n      classificationType\n      instructions\n      additionalReceivers\n    }\n    permissions\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = '04e1a5b6db9b6ab14cfa71f4fe9d47af';
module.exports = node;
